import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getBookingCustomerApi } from "../../../api/booking";

// First, create the thunk
export const fetchBooking = createAsyncThunk(
  "booking/fetchBooking",
  async ({ query }: { query: string }) => {
    try {
      const response = await getBookingCustomerApi(query);
      return response.data;
    } catch (error) {}
  }
);

const initialState: any = {
  isFetching: true,
  pagination: {
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
  },
  result: [],
};

export const listBooking = createSlice({
  name: "listBooking",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchBooking.pending, (state) => {
      state.isFetching = true;
    });

    builder.addCase(fetchBooking.rejected, (state) => {
      state.isFetching = false;
    });

    builder.addCase(fetchBooking.fulfilled, (state, action) => {
      state.isFetching = false;
      state.pagination = action.payload?.pagination;
      state.result = action.payload?.data;
    });
  },
});

export const {} = listBooking.actions;

export default listBooking.reducer;
